import { useRef } from "react";

// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormLabel,
  Grid,
  Typography,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import componentStylesDialog from "assets/theme/components/dialog";
import MaskAndValid from "utils/maskAndValid";

const useStyles = makeStyles({
  paper: { overflow: "hidden" },
});
const useStylesDialog = makeStyles(componentStylesDialog);

const DetailItem = ({ label, value }) => {
  const valueToRender = value?.toString() || "";

  return (
    <Grid item xs={12}>
      <FormLabel style={{ textTransform: "uppercase", marginBottom: "0.5rem" }}>
        {label.toLowerCase()}
      </FormLabel>
      <Typography
        variant="body2"
        component="p"
        style={{ marginLeft: "0.5rem" }}
      >
        {valueToRender.trim().length > 0 ? valueToRender : "-"}
      </Typography>
    </Grid>
  );
};

const ProductDetailsDialog = ({ details, onClose }) => {
  const classes = { ...useStyles(), ...useStylesDialog() };
  const detailsRef = useRef(null);

  return (
    <Dialog
      open={Boolean(details)}
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      classes={{ paper: classes.paper }}
    >
      <div className={classes.dialogHeader}>
        <Typography variant="h5" component="h5" className={classes.dialogTitle}>
          Detalhes do produto
        </Typography>
      </div>
      <DialogContent
        ref={detailsRef}
        style={{
          paddingRight: "0px",
          marginRight: "1.5rem",
          overflowX: "hidden",
        }}
      >
        <Grid container spacing={2}>
          {details.Especificacoes?.map(({ Descricao, Valor }, index) => (
            <DetailItem key={index} label={Descricao} value={Valor} />
          ))}
          <DetailItem
            label="CEST (Código Específico da Substituição Tributária)"
            value={details.Cest}
          />
          <DetailItem label="CST Cofins" value={details.CstCofins} />
          <DetailItem
            label="Aliquota Cofins"
            value={MaskAndValid.maskDecimal(details.AliquotaCofins)}
          />
          <DetailItem label="CST Pis" value={details.CstPis} />
          <DetailItem
            label="Aliquota Pis"
            value={MaskAndValid.maskDecimal(details.AliquotaPis)}
          />
          <DetailItem label="Origem" value={details.OrigemMercado} />
          <DetailItem label="Classificação Fiscal (NCM)" value={details.Ncm} />
          <DetailItem label="Código de Barras (EAN)" value={details.Ean} />
          <DetailItem
            label="Preço Sug."
            value={details.Preco ? "R$" + details.Preco : ""}
          />
          <DetailItem
            label="Preço de Custo"
            value={details.PrecoCusto ? "R$" + details.PrecoCusto : ""}
          />
          <DetailItem label="Un. Medida" value={details.UnidadeMedida} />
          <DetailItem label="Peso" value={details.PesoProduto} />
          <DetailItem label="Altura" value={details.AlturaProduto} />
          <DetailItem label="Largura" value={details.LarguraProduto} />
          <DetailItem label="Comprimento" value={details.ComprimentoProduto} />
          <DetailItem label="Categoria" value={details.Categoria} />
          <DetailItem label="Subcategoria" value={details.Subcategoria} />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          component={Box}
          onClick={onClose}
          color="primary"
          marginLeft="auto!important"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductDetailsDialog;
